/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  aircraft-validations.ts
 *
 * Project Title :  Checkout
 *
 * Description	 :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Suresh Jaladi (E807958)
 *
 * @Date	     : Nov 20, 2019
 *
 * @Version      : Version 1.0
 *
 ******************************************************************************/
export const indexOfAll = (arr, val) => arr.reduce((acc, el, i) => (el === val ? [...acc, i] : acc), []);

// export const validateAircraftSerialNumber = (serialNumber) => {
//     let hasErrors = false;
//     if (/[^a-zA-Z0-9\- .$&*()_=}{;:\ /]/.test(serialNumber)) {
//         hasErrors = true;
//     }

//     return hasErrors;
// };

// export const validateAircraftTailNumber = (tailNumber) => {
//     let hasErrors = false;
//     if (/[^a-zA-Z0-9\- .$&*()_=}{;:\ /]/.test(tailNumber)) {
//         hasErrors = true;
//     }
//     return hasErrors;
// };

export const validateAircraftType = (aircraftType) => {
    let hasErrors = false;
    if (!aircraftType) {
        hasErrors = true;
    }
    return hasErrors;
};